import React, { useRef, useState } from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import TextField from "@material-ui/core/TextField";
import { Field, Form, Formik } from "formik";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CustomTooltip } from "../CalendarPercent/styles";

const ObjectStock = (props) => {
  const { savePage, objectId, stocksFields } = props


  const [unsavedPage, toggleUnsavedPage] = useState(false)

  const [targetRedirectLink, setTargetRedirectLink] = useState(false)
  const history = useHistory()


  //валидация формы
  const validation = (value) => {
    //если значения формы отличаются от начальных то показывать кнопку сохранить страницу
    if (JSON.stringify(formRef.current.initialValues) != JSON.stringify(value)) {
      toggleUnsavedPage(true)
    } else {
      toggleUnsavedPage(false)
    }

    const error = {}
    if (value.stocksPreview.length >= 70) {
      error.stocksPreview = "Поле не может содержать более 70 символов"
    }
    return error
  }


  //реф формы
  const formRef = useRef()


  //переназначенный submit формы
  const handleSubmit = async (values) => {
    if (formRef.current) {
      formRef.current.handleSubmit()

    }
  }


  //сохранение страницы
  const onSubmit = async (values) => {
    toggleUnsavedPage(false)

    let response = await savePage({ object: objectId, section: "stocksAndDiscounts", data: values })
    if (response) {

      if (targetRedirectLink) {
        history.push(targetRedirectLink)
      }
    }


  }

  return (
    <div className="main edit-object">

      <div className="container-fluid">
        <div id="stocks" className="mb-4">
          <div className="row">
            <div className="col-12 mb-2">
              <Formik innerRef={formRef}
                      enableReinitialize
                      initialValues={{
                        stocksPreview: stocksFields?.stocksPreview ? stocksFields.stocksPreview : '',
                        stocks: stocksFields?.stocks ? stocksFields.stocks : '',
                        discounts: stocksFields?.discounts ? stocksFields.discounts : '',
                      }}
                      validate={validation}
                      onSubmit={onSubmit}>
                {() => (
                  <Form>
                    <div className="stocks-field">
                      <CustomTooltip
                        title={"Будет указано в аннотации объекта на страницах каталога"}
                        arrow placement="top">
                        <Box className='stocks-field__header'>

                          <Typography variant="h6" className="title">
                            Акция
                          </Typography>

                          <FontAwesomeIcon className="icon"
                                           icon={["far", "question-circle"]}/>


                        </Box>
                      </CustomTooltip>
                      <Field name="stocksPreview">
                        {({ field, form }) => (
                          <TextField
                            name={field.name}
                            onChange={field.onChange}
                            value={field.value}
                            label="Акция"
                            multiline
                            fullWidth
                            rows={3}
                            variant="outlined"
                            inputProps={{ maxLength: 50 }}
                            helperText={`${field.value?.length ? field.value?.length : 0}/50`}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="stocks-field">
                      <CustomTooltip
                        title={"Будет указано на странице объекта, развернутое описание акций или сезонных предложений которые действую на выбранном объекте"}
                        arrow placement="top">
                        <Box className='stocks-field__header'>

                          <Typography variant="h6" className="title">
                            Акции
                          </Typography>

                          <FontAwesomeIcon className="icon"
                                           icon={["far", "question-circle"]}/>


                        </Box>
                      </CustomTooltip>
                      <Field name="stocks">
                        {({ field, form }) => (
                          <TextField
                            name={field.name}
                            onChange={field.onChange}
                            value={field.value}
                            label="Акции"
                            multiline
                            fullWidth
                            rows={7}
                            variant="outlined"
                            inputProps={{ maxLength: 200 }}
                            helperText={`${field.value?.length ? field.value?.length : 0}/200`}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="stocks-field">
                      <CustomTooltip
                        title={"Будет указано на странице объекта, описание возможных скидок которые действуют на Вашем объекте, например скидка при проживание от 15 дней"}
                        arrow placement="top">
                        <Box className='stocks-field__header'>

                          <Typography variant="h6" className="title">
                            Скидки
                          </Typography>

                          <FontAwesomeIcon className="icon"
                                           icon={["far", "question-circle"]}/>


                        </Box>
                      </CustomTooltip>
                      <Field name="discounts">
                        {({ field, form }) => (
                          <TextField
                            name={field.name}
                            onChange={field.onChange}
                            value={field.value}
                            label="Скидки"
                            multiline
                            fullWidth
                            rows={7}
                            variant="outlined"
                            inputProps={{ maxLength: 200 }}
                            helperText={`${field.value?.length ? field.value?.length : 0}/200`}
                          />
                        )}
                      </Field>
                    </div>

                  </Form>

                )}
              </Formik>
            </div>


          </div>

        </div>
        {unsavedPage && <StickyBottomButton action={handleSubmit}/>}


        <AlertSavePage unsavedPage={unsavedPage} btnOkAction={handleSubmit}
                       setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>

      </div>
      <FunctionSidebarContainer/>
    </div>
  )
}


export default ObjectStock;
